'use client';

import { usePathname } from 'next/navigation';
import NavBar from './home/NavBar';
import HomeFooter from './home/HomeFooter';
import "../styles/nav.css";

export default function ConditionalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  // Define routes where you DO NOT want navbar/footer
//   const hiddenLayoutRoutes = ['/auth', '/organisation-setup'];

//   const isAuthRoute = hiddenLayoutRoutes.some((path) =>
//     pathname.startsWith(path)
//   );
  const isAuthRoute = /^\/(auth|dashboard|employee|organisation-setup|login)(\/|$)/.test(pathname);

  return (
    <>
      {!isAuthRoute && <NavBar />}
      <main>{children}</main>
      {!isAuthRoute && <HomeFooter />}
    </>
  );
}
